<!-- BTN EXPORT -->
<button type="button" class="btn-icon-create-order">
    <div class="icon-create-order">
        <span class="margin-start-icon">
            {{'user.create_user' | translate}}
        </span>
    </div>
</button>